import { get, postJSON, del, post } from '../utils/axios'

// 查询员工信息
interface infoProps {
    name?: string //模糊搜索名称
    orgPk?: string //组织PK
    page?: string | number //当前页
    size?: string | number //每页大小
}
export const getUserAllInfo = (options: infoProps) => get('/yme-agency/user/getUserAllInfo', options)

// IOT项目-奖励配置列表
interface optionsProps {
    page?: string | number //当前页
    orgName?: string | number //组织名称
    size?: string //每页大小
    store?: string //组织类型 0-集团 1-4S 2-维修（门店） 3-经销商（代理商）
    cloudServicesName?: string //项目名称-云服务名称
    cooperationStartDay?: string //合作开始天数
    cooperationEndDay?: string //合作结束天数
    cumulativeStartSales?: string //累计开始销售额(元)
    cumulativeEndSales?: string //累计结束销售额(元)
    collectionStartAmount?: string //累计开始回款金额(元)
    collectionEndAmount?: string //累计结束回款金额(元)
    rewardConf?: string //奖励配置 0-未配置 1-已配置
    realTimeRewards?: string //实时奖励 0-未开启 1-已开启
    createStartTime?: string //创建开始时间 年月日
    createEndTime?: string //开始结束时间 年月日
}
export const getIotRewardConfList = (options: optionsProps) => postJSON('/yme-agency/rewardConf/getIotRewardConfList', options)

// 根据门店配置PK查询奖励配置信息
export const getIotRewardConfByPk = (pk: string) => get(`/yme-agency/rewardConf/getIotRewardConfByPk/${pk}`, { pk })

// 保存还是修改IOT项目-奖励配置
/**
 * 商户提成rel门店配置-奖励配置-商户提成
 */
interface merchantCommissionListItem {
    createTime?: string //创建时间
    pk?: string //业务员PK
    updateTime?: string //修改时间
    salesManPk?: string //业务员PK
    roleName?: string //角色名称
    commission?:string //提成比例
    remark?:string //备注
}
/**
 * //施工奖励rel
 */
interface constructionRewardTypeListItem {
    type?: string //0-施工奖励 1-销售奖励
    integral?: string //积分
    storeRewardsType?: string //平台项目-奖励方式 0-每台 1-每单位
    reward?: string //奖励(元)
}
interface constructionRewardListItem {
    cloudId: string //云商品ID
    constructionRewardTypeList:constructionRewardTypeListItem[]
}

/**
 * //检测奖励rel门店配置-检测奖励DTO
 */
 interface detectionRewardTypeListItem {
    type?: string //0-检测奖励 1-开口奖励
    integral?: string //积分
    reward?: string //奖励(元)
}
interface detectionRewardListItem {
    checkPk: string //点检PK
    detectionRewardTypeList:detectionRewardTypeListItem[]
}

interface movingCommissionListItem {
    createTime?: string //创建时间
    pk?: string //商户提成明细PK 修改要传
    updateTime?: string //修改时间
    salesManPk?: string //业务员PK
    roleName?: string //角色名称
    salesManName?: string //业务员名称
    commission?: string //提成比例
    remark?: string //备注
}

interface movingCommodityListItem {
    pk?: string //主键
    storeConfPk?: string //门店项目配置PK
    cloudId?: string //云商品ID
    commissionAmount?: string //动销提成金额
    images?: string //商品图片 多个逗号隔开
    commodityNumber?: string //商品编码
    commodityName?: string //商品名称
    commoditySpecs?: string //商品规格
    commodityUnit?: string //商品单位
    storeRewards?: string //门店奖励(元)
}

interface saveIotRewardConfProps {
    pk?: string //门店配置PK
    royaltyPayment?: string //提成发放 0-关闭 1-开启
    storeRewardDistribution?: string //门店奖励 0-关闭 1-开启
    movingCommission?: string //商户动销提成发放 0-关闭 1-开启
    discontinue?: string //中止合作 0-否 1-是
    discontinueTime?: string //中止合作日期
    merchantCommissionList: merchantCommissionListItem[] //商户提成rel门店配置-奖励配置-商户提成
    constructionRewardList: constructionRewardListItem[] //施工奖励rel
    detectionRewardList: detectionRewardListItem[] //检测奖励rel门店配置-检测奖励DTO
    movingCommissionList: movingCommissionListItem[] //商户动销提成业务员比例rel
    movingCommodityList: movingCommodityListItem[] //商户动销商品rel
}
export const saveIotRewardConf = (options: saveIotRewardConfProps) => postJSON('/yme-agency/rewardConf/saveIotRewardConf', options)

// H5-IOT项目-获取全部门店列表
interface storeConfListProps {
    page?: string //当前页
    size?: string //每页大小
    storeName?: string //门店名称
    cloudServicesName?: string //项目名称-云服务名称
    createStartTime?: string //创建开始时间 年月日
    createEndTime?: string //开始结束时间 年月日
}
export const getGroupByStoreConfList = (options: storeConfListProps) => postJSON('/yme-agency/storeConf/getGroupByStoreConfList', options)

//H5-IOT项目-获取门店配置-累计销售额
interface getStoreConfCumulativeSalesProps {
    storePk?: string //门店PK
    cloudServicesPk?: string //云服务PK
    page?: string | number //当前页
    rewardUserPk?: string //奖励用户PK
    size?: string | number //每页大小
}
export const getStoreConfCumulativeSales = (options: getStoreConfCumulativeSalesProps) => postJSON('/yme-agency/storeConf/getStoreConfCumulativeSales', options)

//H5-IOT项目-获取门店配置-累计回款金额
interface getStoreConfCollectionAmountProps {
    storePk?: string //门店PK
    cloudServicesPk?: string //云服务PK
    page?: string //当前页
    rewardUserPk?: string | number //奖励用户PK
    size?: string | number //每页大小
}
export const getStoreConfCollectionAmount = (options: getStoreConfCollectionAmountProps) => postJSON('/yme-agency/storeConf/getStoreConfCollectionAmount', options)

//H5-IOT项目-获取门店配置-累计提成-头部统计
interface getStoreConfAccumulatedCommissionStatisticsProps {
    storePk?: string //门店PK
    cloudServicesPk?: string //云服务PK
    page?: string | number //当前页
    rewardUserPk?: string | number //奖励用户PK
    size?: string | number //每页大小
}
export const getStoreConfAccumulatedCommissionStatistics = (options: getStoreConfAccumulatedCommissionStatisticsProps) => postJSON('/yme-agency/storeConf/getStoreConfAccumulatedCommissionStatistics', options)


//H5-IOT项目-获取门店配置-累计提成
export const getStoreConfAccumulatedCommission = (options: getStoreConfAccumulatedCommissionStatisticsProps) => postJSON('/yme-agency/storeConf/getStoreConfAccumulatedCommission', options)

//H5-IOT项目-获取门店配置-累计奖励-头部统计
export const getStoreConfCumulativeRewardsStatistics = (options: getStoreConfAccumulatedCommissionStatisticsProps) => postJSON('/yme-agency/storeConf/getStoreConfCumulativeRewardsStatistics', options)

//H5-IOT项目-获取门店配置-累计奖励
export const getStoreConfCumulativeRewards = (options: getStoreConfAccumulatedCommissionStatisticsProps) => postJSON('/yme-agency/storeConf/getStoreConfCumulativeRewards', options)
